import { render } from "./OrderItemPaymentTable.vue?vue&type=template&id=2ba95a5a"
import script from "./OrderItemPaymentTable.vue?vue&type=script&lang=js"
export * from "./OrderItemPaymentTable.vue?vue&type=script&lang=js"

import "./OrderItemPaymentTable.vue?vue&type=style&index=0&id=2ba95a5a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QMarkupTable,QChip,QTooltip});
